export default __webpack_public_path__ + "static/media/logo-humane-white.53965a89.svg";